import { useMemo } from "react";
import { useDraft } from "./useDraft";
import { useSelectedFile } from "./useSelectedFile";
import { DocumentType } from "@/entities/DataAssociation/File.model";
import { AccountAppearanceState } from "../Labeling.types";
import { isRowDisabled } from "../Labeling.helpers";

export function useRowData() {
    const { selectedFileId } = useSelectedFile();
    const { draft, draftEdits, isReadonly, isCodat } = useDraft();

    const rowData = useMemo(() => {
        if (!selectedFileId || !draft.data?.rows) return [];

        return Object.keys(draft.data.rows).map((key) => {
            const baseRow = draft.data.rows[key];
            const editRow = isReadonly ? null : (draftEdits.rows || {})[key];
            const isDisabled = isRowDisabled(
                isCodat,
                baseRow.account?.meta?.codatAccountId,
            );
            let accountAppearanceState = AccountAppearanceState.DEFAULT;

            if (draft.data.documentType === DocumentType.CLEANED) {
                if (isDisabled) {
                    accountAppearanceState = AccountAppearanceState.DISABLED;
                } else if (!editRow || isReadonly) {
                    accountAppearanceState = AccountAppearanceState.TENTATIVE;
                }
            } else if (
                draft.data.documentType === DocumentType.LABELED &&
                isDisabled
            ) {
                accountAppearanceState = AccountAppearanceState.DISABLED;
            }

            return {
                rowHeader: baseRow.rowHeader,
                values: baseRow.values || [],
                account: editRow?.account || baseRow.account,
                rowIndex: key,
                accountAppearanceState,
                canChangeAccount: !isDisabled,
            };
        });
    }, [draft.data?.rows, draftEdits.rows, selectedFileId]);

    return rowData;
}
